import { render, staticRenderFns } from "./SliderResult.vue?vue&type=template&id=2167e307&scoped=true"
import script from "./SliderResult.vue?vue&type=script&lang=js"
export * from "./SliderResult.vue?vue&type=script&lang=js"
import style0 from "./SliderResult.vue?vue&type=style&index=0&id=2167e307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167e307",
  null
  
)

export default component.exports